<!-- 数字报文章目录组件 -->
<template>
  <div class="article_directions">
    <div v-if="showCategory">
      <div class="shade" @click="$emit('close')"></div>
      <div class="main">
        <ul>
          <li v-for="item in categoryArr">
            <a @click="goToDetail(item)" v-text="item.documentTitle"></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ArticleDirections',
  props: {
    categoryArr: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showCategory: true,
      title: ''
    };
  },
  mounted() {
    this.title = document.title;
  },
  methods: {
    //点击展开或关闭目录
    showCategoryFn() {
      this.showCategory = !this.showCategory;
    },
    /**
     * [goToDetail description]跳转至详情页
     * @param  {[type]} item [description]当前文章
     * @return {[type]}      [description]
     */
    goToDetail(item) {
      let href = this.$router.resolve({
        name: 'newspapersDetail',
        query: {
          id: item.layoutDetailId,
          title: this.title
        }
      }).href;
      href = window.location.origin + href;
      window.CP.openNewPage({
        url: href,
        title: ''
      });
      /* let $a = $('<a></a>');
      $a.attr({
          href,
          target:'_blank'
      });
      $a[0].click(); */
    }
  }
};
</script>
<style lang="less" scoped>
.article_directions {
  width: 100%;
  height: 100%;

  &>div {
    .shade {
      position: absolute;
      left: 0;
      top: 0.2rem;
      width: 100%;
      height: calc(100% - 0.2rem);
      background: rgba(0, 0, 0, 0.4)
    }

    .main {
      position: absolute;
      bottom: 0;
      padding-top: 20px;
      width: 100%;
      min-height: 44px;
      max-height: 276px;
      overflow-y: auto;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0rem 5px 10px 0 rgba(0, 0, 0, 0.72);

      &::-webkit-scrollbar {
        display: none;
      }

      ul {
        padding: 0;
        margin: 0;

        li {
          height: 44px;
          border-bottom: 1px solid rgba(232, 232, 232, 1);
          line-height: 44px;
          font-size: 14px;
          font-weight: normal;
          color: rgba(42, 42, 42, 1);
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          padding: 0 50px 0rem 20px;
        }
      }
    }
  }
}
</style>